var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"co-col text-center"},[_c('h3',[_vm._v(_vm._s(_vm.chartData.title))]),_c('doughnut',{ref:"chart",staticClass:"chart"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }